import { useTypedQuery } from 'apiTyped/helpers/useTypedQuery';

export const useDashboardData = () => {
  const { isLoading, data, refetch } = useTypedQuery('get', '/dashboard/data');
  const d = data as any;

  return {
    isLoading,
    lastCampaigns: d?.kpis?.last_campaigns || [],
    nextCampaigns: d?.kpis?.next_campaigns || [],
    press: d?.Presse || [],
    notations: d?.Notations || [],
    caves: d?.Caves || [],
    restaurants: d?.Restaurants || [],
    refetch
  };
};
